import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Utenteservice } from '../../../services/utente.service';
import { costantValue } from '../../../services/forms-template.service';
import { alert } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-crm-diario-attivita',
  templateUrl: './crm-diario-attivita.component.html',
  styleUrls: ['./crm-diario-attivita.component.css']
})
export class CrmDiarioAttivitaComponent implements OnInit {
  @Input() dataContatto: any;
  @Input() titolo: string = 'Dario Attività';
  @Input() costantValues: costantValue[] = []
  @Input() service: string = 'crmDiarioAttivitaGrid';
  @Input() api: string = 'diario';
  @Input() gridHeight: string = '600';
  @Input() filter: string = '';
  @Input() modifica: boolean = true
  @Input() aggiungi: boolean = true
  @Input() elimina: boolean = true
  @Input() soloRicercaGlobale: boolean = true
  @Input() ricerca: boolean = false
  @Input() isAdvancedXlsExportAvailable: boolean = false
  @Input() isExportDocxAvailable: boolean = true
  @Input() isExportExcelAvailable: boolean = true
  @Input() isExportPDFAvailable: boolean = true
  @Input() gridWidth
  @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>()
  moment = require('moment');
  constructor(private utenteService: Utenteservice) { }

  ngOnInit() {
    console.log(this.costantValues)
    console.log(this.dataContatto)
  }


  buttonEventAnagrafica(event) {
    console.log(event)
  }

  allEventAnagrafica(event: any) {
    // Verifichiamo prima la struttura dell'evento che riceviamo
    // console.log('Evento ricevuto:', event);
    let evento = event
    if (typeof evento === 'object') {
      evento.emitter = this.constructor.name
    } else {
      evento = {
        event: event,
        emitter: this.constructor.name
      }
    }
    // Il componente nica-anagrafica invia tutti gli eventi attraverso onAllEvent
    // quindi dobbiamo prima verificare se l'evento è quello che ci interessa
    if (event && event.name === "onInitNewRow") {
      // Ora possiamo gestire l'inizializzazione della nuova riga
      const dataOggi = this.moment().format('YYYY-MM-DD HH:MM');
      const utente = this.utenteService.InfoDatiUtenteConnesso.nomeCompleto || ''
      if (event.component && event.component.option) {
        // Se l'evento ha la struttura DevExtreme standard
        event.data = {
          DataInserimento: dataOggi,
          UtenteCheInserisce: utente || 'Utente',
          CodSede: 0
        };
      } else {
        // Se l'evento ha una struttura personalizzata di nica-anagrafica
        event = {
          ...event,
          data: {
            dataCreazione: dataOggi,
            UtenteCheInserisce: utente || 'Utente',
            CodSede: 0
          },
          cancel: true
        };
      }
    }

    if (event && event.name === "beforSave") {
      this.checkValueState(event)
      //alert('Stato Aperto','Errore')
    }

    this.onAllEvent.emit(evento)
  }

  checkValueState(event: any) {
    console.log(event)
    if (event.formData['Stato'] === 2) {
      if (event.formData['DataConclusione'] === null) {
        event.cancella = true
        //event.masterComponent.elementRef['DataConclusione'].onInitialized.component.option('isValid', false);
        alert('Popolare Data Conclusione', 'Errore')
      }

    } else if (event.formData['Stato'] !== 2 && event.formData['DataConclusione'] !== null) {
      event.cancella = true
      //event.masterComponent.elementRef['DataConclusione'].onInitialized.component.option('isValid', false);
      alert('Se lo stato è Aperto, Data Conclusione non può essere popolato', 'Errore')
    }
  }


}
